//@flow

import React from 'react';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import { connect } from 'react-redux';
import { FormGroup, Label, InputGroup, InputGroupAddon } from 'reactstrap';

import { changeTrekTemplateStartDate } from '../../../redux/actions/trekPaymentReviewActions';
import '../../../../node_modules/flatpickr/dist/themes/airbnb.css';

const mapDispatchToProps = dispatch => ({
  onChangeDate: date =>
    dispatch(changeTrekTemplateStartDate(moment(date[0]).format('YYYY-MM-DD'))),
});

const mapActionToProps = ({
  trekPayment: { trekTemplateStartDate },
  selectedTrek: {
    trek: { start_date },
  },
}) => ({
  date: trekTemplateStartDate || start_date,
});

type Props = {
  date: number,
  onChangeDate: (date: Array<String>) => void,
  error?: string,
  hideLabel?: Boolean,
};

const ConnectedCounter = ({ date, onChangeDate, error, hideLabel }: Props) => (
  <FormGroup>
    {hideLabel ? null : <Label>Pick a start date</Label>}
    <InputGroup>
      <InputGroupAddon addonType="prepend">
        <span className="input-group-text">
          <i className="icon icon-hg-calendar" />
        </span>
      </InputGroupAddon>
      <Flatpickr
        id="flatpickr-trek-review"
        options={{
          minDate: 'today',
          disableMobile: 'true',
          dateFormat: 'd M Y',
          defaultDate: moment(date).format('DD MMM YYYY'),
        }}
        onClose={onChangeDate}
        placeholder="Pick a date"
        className={`form-control datepicker ${error ? 'is-invalid' : ''}`}
      />
    </InputGroup>
    {error && <p className="error">{error}</p>}
  </FormGroup>
);

export default connect(
  mapActionToProps,
  mapDispatchToProps
)(ConnectedCounter);



// WEBPACK FOOTER //
// ./src/screens/Trek/Common/ConnectedDatePicker.js